import { render } from "./ProductReplacementStepOne.vue?vue&type=template&id=ec1f4b7e"
import script from "./ProductReplacementStepOne.vue?vue&type=script&lang=js"
export * from "./ProductReplacementStepOne.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__